const base = {
  male: [
    require('../../../docs/vr1game-qilin/assets-v1/pet/qilin-stage1.png'),
    require('../../../docs/vr1game-qilin/assets-v1/pet/qilin-stage2.png'),
    require('../../../docs/vr1game-qilin/assets-v1/pet/qilin-stage3.png'),
    require('../../../docs/vr1game-qilin/assets-v1/pet/qilin-stage4.png'),
    require('../../../docs/vr1game-qilin/assets-v1/pet/qilin-stage5.png'),
    require('../../../docs/vr1game-qilin/assets-v1/pet/qilin-stage6.png'),
    require('../../../docs/vr1game-qilin/assets-v1/pet/qilin-stage7.png')
  ],
  female: [
    require('../../../docs/vr1game-qilin/assets-v1/pet/qilin-f-stage1.png'),
    require('../../../docs/vr1game-qilin/assets-v1/pet/qilin-f-stage2.png'),
    require('../../../docs/vr1game-qilin/assets-v1/pet/qilin-f-stage3.png'),
    require('../../../docs/vr1game-qilin/assets-v1/pet/qilin-f-stage4.png'),
    require('../../../docs/vr1game-qilin/assets-v1/pet/qilin-f-stage5.png'),
    require('../../../docs/vr1game-qilin/assets-v1/pet/qilin-f-stage6.png'),
    require('../../../docs/vr1game-qilin/assets-v1/pet/qilin-f-stage7.png')
  ]
}

const animated = {
  male: [
    require('../../../docs/vr1game-qilin/assets-v1/pet/anim/qilin-stage1-blink.png'),
    require('../../../docs/vr1game-qilin/assets-v1/pet/anim/qilin-stage2-blink.png'),
    require('../../../docs/vr1game-qilin/assets-v1/pet/anim/qilin-stage3-blink.png'),
    require('../../../docs/vr1game-qilin/assets-v1/pet/anim/qilin-stage4-blink.png'),
    require('../../../docs/vr1game-qilin/assets-v1/pet/anim/qilin-stage5-blink.png'),
    require('../../../docs/vr1game-qilin/assets-v1/pet/anim/qilin-stage6-blink.png'),
    require('../../../docs/vr1game-qilin/assets-v1/pet/anim/qilin-stage7-blink.png')
  ],
  female: [
    require('../../../docs/vr1game-qilin/assets-v1/pet/anim/qilin-f-stage1-blink.png'),
    require('../../../docs/vr1game-qilin/assets-v1/pet/anim/qilin-f-stage2-blink.png'),
    require('../../../docs/vr1game-qilin/assets-v1/pet/anim/qilin-f-stage3-blink.png'),
    require('../../../docs/vr1game-qilin/assets-v1/pet/anim/qilin-f-stage4-blink.png'),
    require('../../../docs/vr1game-qilin/assets-v1/pet/anim/qilin-f-stage5-blink.png'),
    require('../../../docs/vr1game-qilin/assets-v1/pet/anim/qilin-f-stage6-blink.png'),
    require('../../../docs/vr1game-qilin/assets-v1/pet/anim/qilin-f-stage7-blink.png')
  ]
}

const hungry = {
  male: [1, 2, 3, 4, 5, 6, 7].map(stage => require(`../../../docs/vr1game-qilin/assets-v1/pet/qilin-stage${stage}-hungry.png`)),
  female: [1, 2, 3, 4, 5, 6, 7].map(stage => require(`../../../docs/vr1game-qilin/assets-v1/pet/qilin-f-stage${stage}-hungry.png`))
}

const sulking = {
  male: [1, 2, 3, 4, 5, 6, 7].map(stage => require(`../../../docs/vr1game-qilin/assets-v1/pet/qilin-stage${stage}-sulking.png`)),
  female: [1, 2, 3, 4, 5, 6, 7].map(stage => require(`../../../docs/vr1game-qilin/assets-v1/pet/qilin-f-stage${stage}-sulking.png`))
}

export const qilinMenuAssets = {
  pet: base.male[0],
  checkin: require('../../../docs/vr1game-qilin/assets-v1/menu/checkin-1.png'),
  mission: require('../../../docs/vr1game-qilin/assets-v1/menu/mission-1.png')
}

export function qilinStageImage (stage, gender) {
  const safeGender = gender === 'female' ? 'female' : 'male'
  const safeStage = Math.max(1, Math.min(7, Number(stage) || 1)) - 1
  return base[safeGender][safeStage]
}

export function qilinPetImage (pet, allowAnimation = true) {
  const gender = pet && pet.gender === 'female' ? 'female' : 'male'
  const stage = Math.max(1, Math.min(7, Number(pet && pet.stage ? pet.stage : 1))) - 1
  if (pet && pet.mood === 'sulking') return sulking[gender][stage]
  if (pet && pet.mood === 'hungry') return hungry[gender][stage]
  return allowAnimation ? animated[gender][stage] : base[gender][stage]
}
